export default __webpack_public_path__ + "static/media/Click_Game.a3df8a1d.wav";